document.addEventListener("DOMContentLoaded", () => {

  const sliderContainer = document.querySelector('.slideshow');
  const indicatorContainer = document.getElementById('indicatorsContainer');
  const firstSection = document.getElementById('categories-section');
  const colorThief = new ColorThief();

  // Cache colors per image URL so repeat views (e.g. navigating back) are instant
  const colorCache = new Map();

  function getActiveImage() {
    const activeSlide = document.querySelector('.slideshow__slide[aria-hidden="false"]');
    if (!activeSlide) return null;
    return activeSlide.querySelector('img');
  }

  function rgbToHex(r, g, b) {
    return "#" + [r, g, b].map(x => {
      const hex = x.toString(16);
      return hex.length === 1 ? "0" + hex : hex;
    }).join("");
  }

  function isLightColor(r, g, b) {
    const brightness = ((r * 299) + (g * 587) + (b * 114)) / 1000;
    return brightness > 210;
  }

  function applyColor(r, g, b) {
    if (isLightColor(r, g, b)) {
      r = 22; g = 64; b = 120;
    }
    const color1 = `rgb(${r}, ${g}, ${b})`;
    const color2 = '#ffffff';

    console.log("Applied color:", color1, "Hex:", rgbToHex(r, g, b));

    if (firstSection) {
      firstSection.style.background = `linear-gradient(to bottom, ${color1}, ${color2})`;
    }
    if (indicatorContainer) indicatorContainer.style.backgroundColor = color1;
    if (sliderContainer) sliderContainer.style.backgroundColor = color1;
  }

  // Build a small CDN-resized version of the same image, purely for sampling
  function getThumbUrl(fullSrc) {
    try {
      const url = new URL(fullSrc, window.location.origin);
      url.searchParams.set('width', '60');
      return url.toString();
    } catch {
      return fullSrc;
    }
  }

  function applyGradient(image) {
    if (!image || !image.src) return;

    const key = image.src.split('?')[0]; // ignore query params for cache key

    if (colorCache.has(key)) {
      const [r, g, b] = colorCache.get(key);
      applyColor(r, g, b);
      return;
    }

    const thumb = new Image();
    thumb.crossOrigin = "anonymous";

    thumb.onload = () => {
      try {
        const dominant = colorThief.getColor(thumb);
        colorCache.set(key, dominant);
        applyColor(dominant[0], dominant[1], dominant[2]);
      } catch (error) {
        console.error("Color extraction failed:", error);
      }
    };

    thumb.onerror = () => {
      console.error("Thumbnail load failed for color sampling");
    };

    thumb.src = getThumbUrl(image.src);
  }

  const initialImage = getActiveImage();
  if (initialImage) applyGradient(initialImage);

  const observer = new MutationObserver(() => {
    const activeImage = getActiveImage();
    if (!activeImage) return;
    applyGradient(activeImage);
  });

  if (sliderContainer) {
    observer.observe(sliderContainer, {
      attributes: true,
      subtree: true,
      attributeFilter: ['aria-hidden']
    });
    sliderContainer.setAttribute("aria-live", "off");
  }

});